import React from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"

const SpecialRequestInput = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <div>
      <Form.Label htmlFor="stw-special-request">Special Request</Form.Label>
      <Form.Textarea
        id="stw-special-request"
        {...register("special_request")}
        hasErrors={Boolean(errors?.special_request)}
        rows={2}
      />
      <div className="text-muted italic">
        Special request will be visible to the customer.
      </div>
      {errors?.special_request && (
        <Form.Error>{errors?.specialRequest?.message}</Form.Error>
      )}
    </div>
  )
}

export default SpecialRequestInput
